import React from 'react';
import styled from '@marvelapp/styled';
import { Box, Flex, FullHeight } from '@marvelapp/ui';
import { Heading } from './Heading';
import { FoamFingerLogo } from './Logos';
import { Text } from './Text';
export function InfoPage({ children, fullHeight = true, heading, kind, subheading, }) {
    return (React.createElement(FullHeightContainer, { fullHeight: fullHeight },
        React.createElement(Container, null,
            React.createElement(Body, null,
                React.createElement(FoamFingerLogo, { kind: kind, width: "160px", height: "160px" }),
                React.createElement(Heading, { as: "h1", fontWeight: "bold", marginBottom: "xs", marginTop: "s", size: "xl", maxWidth: [280, 280, '100%'] }, heading),
                React.createElement(Text, { maxWidth: 440 }, subheading),
                children && React.createElement(Box, { marginTop: "m" }, children)))));
}
function FullHeightContainer({ children, fullHeight, }) {
    if (fullHeight) {
        return React.createElement(FullHeight, null, children);
    }
    return React.createElement(React.Fragment, null, children);
}
const Container = styled(Flex).attrs({
    padding: 'l',
}) `
  align-items: center;
  justify-content: center;
  min-height: 100%;
`;
const Body = styled(Flex) `
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
`;
